import { z } from 'zod';
const uuidSchema = z.string().uuid();
export const platformTenantContextSchema = z.strictObject({
    tenantId: uuidSchema,
    tenantSlug: z.string().min(2).max(80).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    actorUserId: uuidSchema,
    membershipId: uuidSchema,
    roleKeys: z.array(z.string().min(1).max(100)),
    permissions: z.array(z.string().min(3).max(160)),
    entitledModuleIds: z.array(z.string().min(2).max(64)),
    enabledModuleIds: z.array(z.string().min(2).max(64)),
    entitlementVersion: z.number().int().nonnegative(),
    configurationReleaseId: uuidSchema.nullable(),
    membershipRevision: z.number().int().positive(),
    permissionRevision: z.number().int().positive(),
    sessionRevision: z.number().int().positive(),
    requestId: uuidSchema,
    actorType: z.enum(['user', 'public-link', 'webhook', 'worker', 'system']),
    dataLocation: z.string().min(1).max(120),
});
//# sourceMappingURL=platform-tenant-context.contract.js.map